import styled from 'styled-components';
import {
  ChevronIcon,
  SadIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';

const OtherClaimsContainerStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding: 24px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c9cfd7;
  background: #fff;

  @media (min-width: 769px) {
    grid-template-columns: ${props =>
      props.showClaimsTracking ? 'auto auto' : '1fr'};
  }
`;

const ClaimsTrackingStyled = styled.div`
  grid-row: 2/2;
  height: 100%;
  @media (min-width: 769px) {
    grid-row: 1/2;
    max-width: 380px;
  }
`;

const BoxButtonContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
`;

const BoxStyled = styled.div`
  display: flex;
  padding: 16px 24px;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c9cfd7;
  background: #fff;
  cursor: pointer;

  & > svg {
    min-width: 40px;
  }
`;

const InfoBoxStyled = styled.div`
  & > h1 {
    color: #0e141d;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }
  & > p {
    color: #494c66;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
`;

const ChevronIconContainerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  margin-left: auto;
`;

const ChevronStyled = styled(ChevronIcon)`
  transform: rotate(-90deg);

  path {
    fill: #e92070;
  }
`;

const SadIconStyled = styled(SadIcon)`
  transform: scale(1.3);
  margin-left: 5px;

  path {
    fill: #4d008c;
  }
`;
export {
  OtherClaimsContainerStyled,
  ClaimsTrackingStyled,
  BoxButtonContainerStyled,
  BoxStyled,
  InfoBoxStyled,
  ChevronIconContainerStyled,
  ChevronStyled,
  SadIconStyled,
};
